"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeSwapParamsForStandardPoolsOnly = exports.encodeSwapParamsForStandardAndStablePools = void 0;
const utils_1 = require("../../utils");
const trade_1 = require("./trade");
function encodeSwapParamsForStandardPoolsOnly(api, trade, minimumAmountOut) {
    const amountIn = trade.inputAmount.toString(true);
    const amountOutMin = minimumAmountOut.toString(true);
    const path = trade.path
        .reduce((result, currentPathElement) => [...result, currentPathElement.output], [trade.path[0].input])
        .map((currency) => (0, utils_1.newCurrencyId)(api, currency));
    return { amountIn, amountOutMin, path };
}
exports.encodeSwapParamsForStandardPoolsOnly = encodeSwapParamsForStandardPoolsOnly;
function encodeSwapParamsForStandardAndStablePools(api, trade, minimumAmountOut) {
    const amountIn = trade.inputAmount.toString(true);
    const amountOutMin = minimumAmountOut.toString(true);
    const path = trade.path.map((pathElement) => (0, trade_1.isStableMultiPathElement)(pathElement)
        ? {
            Stable: {
                poolId: pathElement.pool.poolId,
                // Pass 0 explicitly if swap is not going through base pool
                basePoolId: (0, trade_1.isStableMetaMultiPathElement)(pathElement) ? pathElement.basePool.poolId : 0,
                mode: (0, trade_1.isStableMetaMultiPathElement)(pathElement)
                    ? pathElement.fromBase
                        ? "FromBase"
                        : "ToBase"
                    : "Single",
                fromCurrency: (0, utils_1.newCurrencyId)(api, pathElement.input),
                toCurrency: (0, utils_1.newCurrencyId)(api, pathElement.output),
            },
        }
        : {
            Normal: [(0, utils_1.newCurrencyId)(api, pathElement.input), (0, utils_1.newCurrencyId)(api, pathElement.output)],
        });
    return { amountIn, amountOutMin, path };
}
exports.encodeSwapParamsForStandardAndStablePools = encodeSwapParamsForStandardAndStablePools;
//# sourceMappingURL=encoding.js.map